import { catchError } from 'rxjs/operators';
import { environment } from './../../environments/environment';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Cargo } from '../models/cargo.model';
import { CargoNew } from '../models/cargonew.model';
import { CargoCsvDTO } from '../models/cargoCsvDTO.model';

@Injectable({
  providedIn: 'root'
})
export class CargoService {
  configHeader: { headers: { Authorization: any; }; };

  constructor(
    private http: HttpClient
    ) { }

  public getById(id: number): Observable<Cargo> {
    return this.http.get<Cargo>(`${environment.url_api}/cargos/${id}`)

  }

  public getByIdCargo(idCargo: number, token: string) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },

        this.http.get(`${environment.url_api}/cargos/${idCargo}`, this.configHeader).subscribe(
          payload => {
            resolve(payload);
            }, err => {
              reject(err.error);
            }
        )
    })
  }

  public getCargosByEleicao(idEleicao: number, token: string): Observable<Cargo[]> {
    const headers = { 'Authorization': token };
    const options = { headers };
    return this.http.get<Cargo[]>(`${environment.url_api}/cargos/byEleicao/${idEleicao}`, options);
  }

  public getAll(): Observable<Cargo[]> {
    return this.http.get<Cargo[]>(`${environment.url_api}/cargos`);
  }

  public cadastrarCargoEleicao(cargo: CargoNew, token) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.post(`${environment.url_api}/cargos`, cargo, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }
      )
    })
  }

  public editarCargoEleicao(cargo: CargoNew, token, idCargo: Number) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.put(`${environment.url_api}/cargos/${idCargo}`, cargo, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }
      )
    })
  }

  public excluirCargoEleicao(idCargo: Number, token) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.delete(`${environment.url_api}/cargos/${idCargo}`, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }
      )
    })
  }

  public insercaoEmMassaCargos(cargo: CargoCsvDTO[], token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.post(`${environment.url_api}/cargos/bulk`, cargo, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }
      )
    })
  }

}
